import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import StarEmpty from '../../../design-system/icons/core/star-empty.svg?component';
import StarFilled from '../../../design-system/icons/core/star-filled.svg?component';
import { RCIcon } from '../RCIcon';

interface IProps {
  onSelect: (number) => void;
  rating: number;
  inputName: string;
}

function Star({ index, rating, onChange, inputName }) {
  const id = `${inputName}-${index}`;
  const checked = Boolean(rating && rating.toString() === index.toString());
  const altText = I18n.t('commons.starRatingSelector.optionText', { count: index });

  return (
    <>
      <input
        className={classNames(
          'rc-star-rating-selector__input',
          { 'rc-star-rating-selector__input--checked': rating >= index },
        )}
        value={index}
        id={id}
        name={inputName}
        type="radio"
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id} className="rc-star-rating-selector__star">
        <span className="rc-star-rating-selector__alt-label">
          {altText}
        </span>
        <span className="rc-star-rating-selector__icon rc-star-rating-selector__icon--filled">
          <RCIcon svgComponent={StarFilled} />
        </span>
        <span className="rc-star-rating-selector__icon rc-star-rating-selector__icon--empty">
          <RCIcon svgComponent={StarEmpty} />
        </span>
      </label>
    </>

  );
}

export function RCStarRatingSelector({ onSelect, rating, inputName }: IProps) {
  const onChange = React.useCallback(
    (evt) => {
      onSelect(parseInt(evt.target.value, 10));
    },
    [onSelect],
  );

  return (
    <div className="rc-star-rating-selector">
      {[1, 2, 3, 4, 5].map((index) => (
        <Star
          key={index}
          index={index}
          onChange={onChange}
          rating={rating}
          inputName={inputName}
        />
      ))}
    </div>
  );
}
